import { create } from 'zustand';
import { getAllConfigValue } from '../api/setting/Configurations';
import { getUserInfo } from '../api/setting/UserInfo';
export const useGlobalStore = create((set, get) => ({
    userInfo: null,
    config: JSON.parse(localStorage.getItem('config') || '[]'),
    token: localStorage.getItem('token') || null,
    permissions: [],
    loading: false,
    error: null,
    currentSystem: localStorage.getItem('rb_currentSystem') || '',
    setCurrentSystem: (sys) => {
        localStorage.setItem('rb_currentSystem', sys);
        set({ currentSystem: sys });
    },
    getCurrentSystem: () => get().currentSystem || '',
    // 更新状态
    getUserInfo: () => {
        let info = JSON.parse(localStorage.getItem('rb_userInfo') || '{}');
        return info;
    },
    setConfig: (config) => {
        localStorage.setItem('config', JSON.stringify(config));
        set({ config });
    },
    setToken: (token) => {
        localStorage.setItem('token', token);
        set({ token });
    },
    setPermissions: (permissions) => set({ permissions }),
    // 清空所有状态
    clearAll: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('rb_userInfo');
        set({ userInfo: null, config: [], token: null, permissions: [] });
    },
    // 获取指定 key 的配置值
    getConfigValue: (key) => {
        const state = get();
        const configItem = state.config.find(item => item.configKey === key);
        return configItem ? configItem.configValue : undefined;
    },
    // 从后台获取配置
    fetchConfigFromServer: async () => {
        set({ loading: true, error: null });
        try {
            const res = await getAllConfigValue({ ConfigGroup: "全局设置" });
            localStorage.setItem('config', JSON.stringify(res.data));
            set({ config: res.data, loading: false });
        }
        catch (error) {
            console.error('获取配置失败:', error);
            set({ loading: false, error: '获取配置失败' });
        }
    },
    // 从后台获取用户信息
    fetchUserInfoAction: async () => {
        const token = get().token;
        if (!token)
            return;
        try {
            const ret = await getUserInfo();
            localStorage.setItem('rb_userInfo', JSON.stringify(ret.data));
            //console.log(ret.data)
            set({ userInfo: ret.data, loading: false });
        }
        catch (error) {
            console.error('获取用户信息失败:', error);
            set({ error: '获取用户信息失败' });
        }
    }
}));
